import axios from './axios';
import store from '../store/store';
import router from './router';
import config from './config';

let verifying = true;

// Changes all of an object's keys to camel case
const sanitise = (obj) => {
  const newObj = {};

  if (obj instanceof Array) {
    return obj.map((value) => {
      if (typeof value === 'object') {
        return sanitise(value);
      }
      return value;
    });
  }

  Object.keys(obj).forEach((origKey) => {
    const newKey = (origKey.charAt(0).toLowerCase() + origKey.slice(1) || origKey).toString();
    let value = obj[origKey];
    if (value instanceof Array || (value !== null && value.constructor === Object)) {
      value = sanitise(value);
    }
    newObj[newKey] = value;
  });

  return newObj;
};

const verifyResponse = async (response) => {
  try {
    if (response.config.excludeToken) return response;

    if (!verifying
      && (response.status !== 200 || response.data.success === false)
      && !router.currentRoute.path.startsWith('/Login')
    ) {
      verifying = true;
      await store.dispatch('verifyToken');
    }
  } finally {
    verifying = false;
  }
  return response;
};

// Add the access token to each request
axios.interceptors.request.use((axiosConfig) => {
  const isWhizeoApiUrl = axiosConfig.url.startsWith(config.microservices.whizeo);
  if (isWhizeoApiUrl || router.currentRoute.path === '/ConversionTools' || router.currentRoute.path.includes('/Widgets')) {
    // eslint-disable-next-line no-param-reassign
    axiosConfig.headers['x-access-token'] = localStorage.getItem('whizeoToken');
  } else if (localStorage.getItem('microserviceToken') && !axiosConfig.excludeToken) {
    // eslint-disable-next-line no-param-reassign
    axiosConfig.headers['x-access-token'] = localStorage.getItem('microserviceToken');
  }
  // Cancel request if impersonator token has changed in another tab
  if (localStorage.getItem('microserviceToken') && store.getters.microserviceToken !== localStorage.getItem('microserviceToken')) {
    store.dispatch('notify', { title: 'Warning', message: 'Action not authenticated, please reload the page' });
    return false;
  }
  return axiosConfig;
});

// Check token on failure
axios.interceptors.response.use(
  (response) => verifyResponse(response),
  (error) => {
    verifyResponse(error.response);
    throw error;
  },
);

// All requests are sanitised to camel case
axios.interceptors.response.use((response) => {
  if (response.headers['content-type'] === 'application/json; charset=utf-8') {
    response.data = sanitise(response.data);
  }
  return response;
});
